import { z } from 'zod';
import { DATE_STRING_REGEX } from '../../utils/constants';
export const UpdateUserAchievementSchema = z
    .object({
    name: z.string().max(255),
    description: z.string().optional().nullable(),
    startedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    endedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable()
})
    .required();
//# sourceMappingURL=updateUserAchievementSchema.js.map